;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"285617070e958ad006f70398d642cb852d11e0d5"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.28";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/pdf/:fileId\",\"regex\":\"^/pdf/([^/]+)$\",\"paramNames\":[\"fileId\"],\"hasOptionalPrefix\":false},{\"path\":\"/start/:page\",\"regex\":\"^/start/([^/]+)$\",\"paramNames\":[\"page\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/freight-dashboard\"},{\"path\":\"/library\"},{\"path\":\"/library/visual\"},{\"path\":\"/login/error\"},{\"path\":\"/logout\"},{\"path\":\"/portal\"},{\"path\":\"/start\"},{\"path\":\"/start/setup\"},{\"path\":\"/start/workspace\"},{\"path\":\"/tracking\"},{\"path\":\"/wilson-instructions\"}],\"isrRoutes\":[]}";import * as Sentry from "@sentry/nextjs"
import { applyXErrorFingerprint } from "@/lib/sentryFingerprint"
import {
    SENTRY_IGNORE_ERRORS,
    SENTRY_DENY_URLS,
} from "@/utils/sentryNoise.utils"

const isSentryEnabled = process.env.NODE_ENV === "production"

Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment:
        process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ||
        process.env.NEXT_PUBLIC_VERCEL_ENV ||
        process.env.NODE_ENV,
    release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    enabled: isSentryEnabled,
    normalizeDepth: 10,
    maxValueLength: 1000,
    ignoreErrors: SENTRY_IGNORE_ERRORS,
    denyUrls: SENTRY_DENY_URLS,
    beforeSend: applyXErrorFingerprint,
})

async function addReplayIntegration() {
    try {
        const replayIntegration =
            await Sentry.lazyLoadIntegration("replayIntegration")
        Sentry.addIntegration(
            replayIntegration({
                maskAllText: false, // boolean-naming-exempt: external contract — Sentry replayIntegration option
                blockAllMedia: false, // boolean-naming-exempt: external contract — Sentry replayIntegration option
            })
        )
    } catch {
        // A network that blocks the Sentry CDN only loses error replays; errors still report
    }
}

function whenIdle(callback: () => void) {
    if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(callback, { timeout: 10_000 })
        return
    }
    window.setTimeout(callback, 3_000)
}

if (isSentryEnabled && typeof window !== "undefined") {
    whenIdle(() => void addReplayIntegration())
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
